import { Activity } from '@/types/activity';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import { useEffect, useState } from 'react';
import { useModel } from 'umi';

dayjs.extend(isToday);

export default () => {
  const [productId, setProductId] = useState<Product.IBase['code']>();
  const [orderId, setOrderId] = useState<Activity.IBase['id']>();
  const [servers, setservers] = useState<Server.IInfo>({
    type: 0,
    list: [],
    rules: [], //规则列表
    ruleFilterTest: true //默认不包含测试服
  }); //选择的服务器
  const [startTime, setStartTime] = useState(dayjs().subtract(1, 'month').valueOf());
  const [endTime, setEndTime] = useState(dayjs().valueOf());
  const [startDate, setStartDate] = useState(dayjs().subtract(1, 'month').format('YYYYMMDD'));
  const [endDate, setEndDate] = useState(dayjs().format('YYYYMMDD'));
  const [survey, setSurvey] = useState<{ id: string; name: string }>();

  const { info } = useModel('useActivity');

  useEffect(() => {
    if (info) {
      setProductId(info?.product.code);
      setOrderId(info?.id);
      const isToday = dayjs(info?.currentTime?.start).isToday();
      const lastDayEnd = dayjs().endOf('day').subtract(1, 'day').valueOf(); // 昨天最后时间
      const todayEnd = dayjs().endOf('day').valueOf(); // 今天最后时间
      const start = isToday ? info?.currentTime?.start : Math.min(info?.currentTime?.start, lastDayEnd);
      const end = isToday ? Math.min(info?.currentTime?.end, todayEnd) : Math.min(info?.currentTime?.end, lastDayEnd);

      setStartTime(start);
      setEndTime(end);
      setStartDate(dayjs(start).format('YYYYMMDD'));
      setEndDate(dayjs(end).format('YYYYMMDD'));
    }
  }, [info]);

  return {
    productId,
    orderId,
    servers,
    setservers,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    survey,
    setSurvey
  };
};
